import React, { Dispatch, ReactElement, useEffect, useRef, useState } from 'react'
import { Flex, Text } from 'theme-ui'
import { SimpleActionMenuItemProps, Svg } from 'ui'
import Check from 'images/analytics/check.svg'
import SettingsDropdown from 'components/Dashboard/Devices/DeviceModalDialog/AddOrEditDevice/SettingsDropdowns/SettingsDropdown'
import { DeviceStatus } from 'store/api/devices/devices.interface'
import {
  ActionType,
  DeviceActionType,
} from 'components/Dashboard/Devices/DeviceModalDialog/AddOrEditDevice/SettingsState'
import { useHideTooltipOnScroll } from 'utils/useHideTooltipOnScroll'

const deviceStatuses = [
  {
    PK: DeviceStatus.PENDING,
    title: 'Pending',
  },
  {
    PK: DeviceStatus.ACTIVE,
    title: 'Active',
  },
  {
    PK: DeviceStatus.SOFT_DISABLED,
    title: 'Soft Disabled',
  },
  {
    PK: DeviceStatus.HARD_DISABLED,
    title: 'Hard Disabled',
  },
]

interface StatusDropdownProps {
  deviceStatus?: DeviceStatus
  settingsDispatch: Dispatch<ActionType>
  boundaryDataTestId?: string
}
export default function StatusDropdown({
  deviceStatus,
  settingsDispatch,
  boundaryDataTestId,
}: StatusDropdownProps): ReactElement {
  const hideRef = useRef<() => void>()
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const scrollingSection = document.getElementById('advanced-settings-section')

    if (scrollingSection) {
      setScrollElement(scrollingSection as HTMLDivElement)
    }
  }, [])

  useHideTooltipOnScroll(hideRef, { current: scrollElement })

  const statOptions: SimpleActionMenuItemProps[] = deviceStatuses.map(status => ({
    isSelected: status.PK === deviceStatus,
    isBackgroundHighlighted: true,
    ariaLabel: `${status.title} option`,
    children: (
      <Flex
        data-testid={status.title}
        sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Text>{status.title}</Text>
        {deviceStatus === status.PK && (
          <Svg
            data-testid="check-icon"
            svg={Check}
            fill="aliceBlue60"
            descriptiveText="Selected status indicator"
          />
        )}
      </Flex>
    ),
    buttonContent: <Text>{status.title}</Text>,
    onClick: async () => {
      settingsDispatch({
        type: DeviceActionType.STATUS,
        payload: status.PK,
      })
      hideRef.current?.()
    },
  }))

  return (
    <SettingsDropdown
      testId="settings-status-dropdown"
      items={statOptions}
      hideRef={hideRef}
      boundaryDataTestId={boundaryDataTestId}
    />
  )
}
